import React, {Component} from "react"
import {Chrono} from "react-chrono";

class TimelineProcess extends Component {
    items = [
        {
            title: "Topic Assessment",
            cardTitle: "Date : 14th -21st of December 2020",
            cardSubtitle: "Marks Allocated – 0/100 ",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fdoc_process.png?alt=media&token=23ed6dde-5f2f-44f0-aca7-4e4d37639fa5"
                }
            }
        },
        {
            title: "Project Charter",
            cardTitle: "Date : 12th January 2021",
            cardSubtitle: "Marks Allocated – 0/100",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fdoc_process.png?alt=media&token=23ed6dde-5f2f-44f0-aca7-4e4d37639fa5"
                }
            }
        },
        {
            title: "Project proposal report",
            cardTitle: "Date : 24th of January 2021",
            cardSubtitle: "Marks Allocated – 6/100",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fdoc_process.png?alt=media&token=23ed6dde-5f2f-44f0-aca7-4e4d37639fa5"
                }
            }
        },
        {
            title: "Project proposal presentation",
            cardTitle: "Date : 1st - 3rd of February 2021",
            cardSubtitle: "Marks Allocated – 6/100",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fpresentation_image1.png?alt=media&token=d5c6a4cc-6fa8-41d3-a9b2-7ac2459b4b44"
                }
            }
        },
        {
            title: "Project Status document",
            cardTitle: "Date : 12th May 2021",
            cardSubtitle: "Marks Allocated – 1/100 ",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fdoc_process.png?alt=media&token=23ed6dde-5f2f-44f0-aca7-4e4d37639fa5"
                }
            }
        },
        {
            title: "Progress Presentation – I (50%)",
            cardTitle: "Date : 10th - 12th May 2021",
            cardSubtitle: "Marks Allocated – 15/100",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fpresentation_image2.png?alt=media&token=eba46f9f-4a39-4fe7-a949-dec8b3153031"
                }
            }
        },
        {
            title: "Research Paper Submission",
            cardTitle: "Date : 2nd August 2021",
            cardSubtitle: "Marks Allocated – N/A",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fpaper_submission_image.png?alt=media&token=1afbb1cd-e0d8-4ecd-ae71-5e15417fa92d"
                }
            }
        },
        {
            title: "Research Paper Acceptance – FICC Conference",
            cardTitle: "Date : 2nd August 2021",
            cardSubtitle: "Marks Allocated - 10/100 | Website: https://saiconference.com/FICC",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fficc_image.png?alt=media&token=19d77216-4547-4e21-880e-b427aac696b9"
                }
            }
        },
        {
            title: "Final Report (draft) Individual and Group",
            cardTitle: "Date : 13th October 2021",
            cardSubtitle: "Marks Allocated -19/100",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fdoc_process.png?alt=media&token=23ed6dde-5f2f-44f0-aca7-4e4d37639fa5"
                }
            }
        },
        {
            title: "Progress Presentation-II (90%) ",
            cardTitle: "Date : 14, 15, 18 – October 2021",
            cardSubtitle: "Marks Allocated – 18/100",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fpresentation_image3.png?alt=media&token=55f30733-b98e-4425-894b-cbc62ba71625"
                }
            }
        },
        {
            title: "Website",
            cardTitle: "Date : 5th November 2021",
            cardSubtitle: "Marks Allocated – 4/100",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fwebsite.png?alt=media&token=82ec31a5-5a32-49a3-afec-c9828ca5ab0f"
                }
            }
        },
        {
            title: "Final Viva",
            cardTitle: "Date : 22, 23 and 24 November 2021",
            cardSubtitle: "Marks Allocated – 20/100",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fviva_image.png?alt=media&token=9cb00bd9-9e41-4841-a5cb-e2884ef7e504"
                }
            }
        },
        {
            title: "Project status document II, Student Logbook, Research paper registration notification",
            cardTitle: "Date : 24th November 2021",
            cardSubtitle: "Marks Allocated – 1/100",
            media: {
                type: "IMAGE",
                source: {
                    url: "https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fdoc_process.png?alt=media&token=23ed6dde-5f2f-44f0-aca7-4e4d37639fa5"
                }
            }
        },

    ];

    render() {
        return (
            < div style={{width: "100%", height: "100%"}}>
                <Chrono
                    items={this.items}
                    slideShow
                    mode="VERTICAL_ALTERNATING"
                    titlePosition="BOTTOM"
                    theme={{
                        primary: "#0c3b2e",
                        secondary: "#FFB100",
                        cardBgColor: "#ffffff",
                        cardForeColor: "#000",
                        titleColor: "#fff"
                    }}
                    enableOutline
                >
                </Chrono>

            </div>
        )
    }


}

export default TimelineProcess;
